module.exports = __webpack_public_path__ + "media/images/rentals-c56cf31b.svg";